
import { LayoutIcon } from "src/libs/useful"
import { __, getContrastColor } from "src/libs/utilities"
import { IEvent } from "../../data/interfaces"
import { eventTypes } from "../../data/mocks/eventTypes"
 
interface IProps {
    item: IEvent 
    className: string
    isShort?: boolean
}

const EventTypeLabel = (props: IProps) : JSX.Element => { 
    const sz = 16 
    return  <div className={` d-flex flex-wrap ${props.className}`} data-testid="event-type-label"> 
        {
            props.item.event_types?.map((pt: string, i: number) => {
                const eventType = eventTypes().filter(et => et.title === pt)[0]
                if(!eventType) return <></>
                return props.isShort && i > 0 
                    ?                    
                    <div 
                        className=" m-1 d-flex align-items-center rounded-pill pointer" 
                        key={ eventType.id } 
                        style={{ background:eventType.color }}
                        title={ __(eventType.title) }
                    >
                        <span className="topos-placetype-label-icon rounded-pill" style={{ height: sz + 12 }}>
                            <LayoutIcon
                                src={ eventType.icon }
                                className=""
                                style={{ width:sz, height: sz }}
                            />
                        </span> 
                    </div>
                    :
                    <div 
                        className=" m-1 d-flex align-items-center rounded-pill pointer"  
                        key={ eventType.id } 
                        style={{ background:eventType.color, height: sz + 12 }}
                    >
                        <span className="topos-placetype-label-icon" style={{ height: sz + 12, width:sz + 18 }}>
                            <LayoutIcon
                                src={ eventType.icon }
                                className=""
                                style={{ width:sz, height: sz }}
                            />
                        </span>
                        <span className="pl-2 pr-3 py-1" style={{ color: getContrastColor(eventType.color) }}>
                            {__(eventType.title)}
                        </span>
                    </div>
            })
        }
    </div> 
}
 
export default EventTypeLabel